import React from 'react';
import { useTranslation } from 'react-i18next';

import { publish, SubscriptionTopic } from '../../../../../../../viewer/messaging/pubsub';
import { DesignTool } from '../../../../../../../viewer/tools/design-tool';
import { CollapsableSection } from '../../../components/collapsable-section';
import { OptionLabels } from '../../../components/option-labels';
import { AttributeList } from './attribute/attribute-list';
import { SetAttributes } from './attribute/set-attributes';

type Props = {
  expanded: boolean;
  tool: DesignTool;
};

enum State {
  AttributeList,
  SetAttributes,
}

export const AttributesSection = (props: Props) => {
  const { t } = useTranslation();
  const [state, setState] = React.useState<State>(State.AttributeList);

  return (
    <CollapsableSection
      expanded={props.expanded}
      title={t('section.attributes.title', { ns: 'skyviewDesign' }).toUpperCase()}
      onSetExpanded={(state) =>
        publish(SubscriptionTopic.DesignToolMenuStateChanged, { configureAttributes: state })
      }
    >
      <OptionLabels
        active={state}
        itemRows={[
          [
            {
              title: t('section.attributes.attributeList.text', { ns: 'skyviewDesign' }),
              value: State.AttributeList,
              onSelect: () => setState(State.AttributeList),
              content: <AttributeList tool={props.tool} />,
              tooltipText: t('section.attributes.attributeList.tooltip', { ns: 'skyviewDesign' }),
            },
          ],
          [
            {
              title: t('section.attributes.setAttributes.text', { ns: 'skyviewDesign' }),
              value: State.SetAttributes,
              onSelect: () => setState(State.SetAttributes),
              content: <SetAttributes tool={props.tool} />,
              tooltipText: t('section.attributes.setAttributes.tooltip', { ns: 'skyviewDesign' }),
            },
          ],
        ]}
      />
    </CollapsableSection>
  );
};
